import React, { useState, useEffect } from 'react';
import StampsTable from '../components/StampsTable';
import FilterBar from '../components/FilterBar';
import Pagination from '../components/Pagination';
import LoadingSpinner from '../components/LoadingSpinner';

export default function Stamps({ stamps, isLoading }) {
  const [filters, setFilters] = useState({
    status: 'all',
    search: '',
    dateRange: 'all'
  });
  const [page, setPage] = useState(1);
  const itemsPerPage = 50;

  const filteredStamps = stamps.filter(stamp => {
    // Search filter
    if (filters.search && !stamp.code.toUpperCase().includes(filters.search.toUpperCase())) {
      return false;
    }

    // Status filter
    if (filters.status !== 'all') {
      if (filters.status === 'paid' && !stamp.purchased) return false;
      if (filters.status === 'unpaid' && stamp.purchased) return false;
      if (filters.status === 'used' && !stamp.used) return false;
      if (filters.status === 'available' && (stamp.used || !stamp.purchased)) return false;
    }

    // Date range filter (simplified - would need actual date comparison in production)
    // For now, we'll just return true
    return true;
  });

  const totalPages = Math.ceil(filteredStamps.length / itemsPerPage);
  const paginatedStamps = filteredStamps.slice(
    (page - 1) * itemsPerPage, 
    page * itemsPerPage
  );

  // Reset to page 1 when filters change
  useEffect(() => {
    setPage(1);
  }, [filters]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Stamps</h1>
        <p className="page-subtitle">
          Manage and track all your postage codes • {filteredStamps.length} total
        </p>
      </div>

      <FilterBar filters={filters} onChange={setFilters} />

      <StampsTable stamps={paginatedStamps} />

      {totalPages > 1 && (
        <Pagination 
          currentPage={page}
          totalPages={totalPages}
          onChange={setPage}
        />
      )}
    </div>
  );
}
